<template>
 <section id="find-us-in-the-wild" class="bg-blue">
      <div class="container-mid mt-3 mb-3">
        <h2 class="teal">Find us in the wild...</h2>
        <div class="row gap-1">
          <div id="upcoming-events" class="card card-container-outline no-m">
              <h4 class="bottom-line teal">Upcoming events</h4>
              <div class="row gap-1">
                <div id="event-img" class="card">
                </div>
                <div class="col gap-1 width-70" v-if="events.length > 0">
                  <EventThumbnail v-for="(eventInfo, index) in events" :eventInfo="eventInfo" :index="index" type="alternate-outline"/>
                  <button class="outline light button-secondary full no-m" @click="goToEvents()">See all</button>
                </div>
                <div v-else class="width-70 col justify-content-center">
                  <p class="large-text teal centered">No upcoming events</p>
                </div>
              </div>
            </div>
          <div id="hosting-workshop" class="right col space-between teal card">
            <h4 class="no-m no-p">Wanna host one of our workshops?</h4>
            <div>
              <p>We love running workshops around our games and introduce little ones to the joy of augmented reality and cross-media stories. Libraries, bookstores, etc, we are up for it! </p>
              <button class="light outline button-secondary full no-m" @click="goToMailto()">Inquire</button>
            </div>
          </div>
        </div>
        <h4 class="teal mt-1">Let's stay connected!</h4>
        <div class="row gap-1">
          <a class="card-container-outline no-m teal social-buttons" href="https://www.instagram.com/redplusbluestories/" target="_blank">
            <img src="../assets/img/sm_ig.png">
          </a>
          <a class="card-container-outline no-m teal social-buttons" href="https://www.youtube.com/@redbluestories">
            <img src="../assets/img/sm_yt.png">
          </a>
          <a class="card-container-outline no-m teal social-buttons" href="https://www.tiktok.com/@redplusbluestories">
            <img src="../assets/img/sm_tiktok.png">
          </a>
        </div>
        <section id="newsletter-signup" class="container-mid mb-2">
          <NewsletterSignupBlock class="newsletter-reverse-mb" :backToWebsite="false"></NewsletterSignupBlock>
        </section>
      </div>
    </section>
</template>


<script>
import NewsletterSignupBlock from "@/components/NewsletterSignupBlock.vue";
import EventThumbnail from "@/components/EventThumbnail.vue";
import router from "@/router/index.js";

export default {
  name: "FullPreFooter",
  components: {EventThumbnail, NewsletterSignupBlock},
  computed: {
    events() {
      return this.$store.getters.getThreeUpcomingEvents;
    }
  },
  methods: {
    goToEvents() {
      router.push('/events')
    },
    goToMailto() {
       window.open('mailto:hello@redbluestories.com');
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/variables.scss";

#find-us-in-the-wild {
  padding: 2em 0;
  border: 1px solid $blue-hover;
}

#hosting-workshop {
  background-color: $blue-hover;
  padding: 1em;
  min-width: calc(30% - 6em);
  width: calc(30% - 6em)
}

#upcoming-events {
  min-width: 70%;
  width: 70%;
}

#event-img {
  background-image: url("../assets/img/event_thumbnail.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: calc(30% - 1em);
  min-height: 300px;
}

.social-buttons {
  img {
    max-height: 60px;
  }
  &:hover {
    background-color: $blue-hover;
  }
}

@media only screen and (max-width: 1024px) {
  #upcoming-events {
    width: 100%;
  }

  #hosting-workshop {
    width: 100%;
    margin-top: 1em;
  }

  #hosting-workshop p {
    padding-top: 1em;
  }
}

@media only screen and (max-width: 747px) {
  #event-img {
      display: none;
  }

  #upcoming-events {
    .width-70 {
      width: 100%;
    }
  }

  #find-us-in-the-wild {
    .width-40 {
      width: unset;
    }
  }

  #newsletter-signup {

  }
}

</style>